import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router';
import { supabase } from '../lib/supabase';
import { useApp } from '../lib/app';
import { Button, Field } from '../ui/kit';
import { Brand } from './Login';
import { LoginBackdrop } from '../ui/LoginBackdrop';

// Used by invite links, password-reset links and "Change password".
export default function SetPassword() {
  const { session, ready } = useApp();
  const nav = useNavigate();
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  async function save(e: FormEvent) {
    e.preventDefault();
    setErr('');
    if (pw.length < 10) return setErr('Use at least 10 characters');
    if (pw !== pw2) return setErr('The two passwords are not the same');
    setBusy(true);
    const { error } = await supabase.auth.updateUser({ password: pw });
    setBusy(false);
    if (error) return setErr(error.message);
    nav('/', { replace: true });
  }

  return (
    <div className="auth login-screen">
      <LoginBackdrop />
      <form className="auth-card" onSubmit={save}>
        <Brand />
        <h1 style={{ fontSize: 22 }}>Set your password</h1>
        {ready && !session ? (
          <div className="error-box">This link has expired or was already used. Ask for a new invite, or use "Forgot password" on the sign-in page.</div>
        ) : (
          <>
            <p className="muted" style={{ margin: 0 }}>Signed in as {session?.user.email ?? '…'}</p>
            <Field label="New password" hint="At least 10 characters">
              <input type="password" autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} />
            </Field>
            <Field label="Type it again">
              <input type="password" autoComplete="new-password" value={pw2} onChange={(e) => setPw2(e.target.value)} />
            </Field>
            {err ? <div className="error-box">{err}</div> : null}
            <Button kind="primary" type="submit" disabled={busy || !session}>
              {busy ? 'Saving…' : 'Save password'}
            </Button>
          </>
        )}
        <a href="/">Back to sign in</a>
      </form>
    </div>
  );
}
